import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import app from '../modules/app/store';
import odemeTalep from '../modules/odemeTalep/store';
import satinAlmaOdemeTalep from '../modules/satinAlmaOdemeTalep/store';
import malzemeOnay from '../modules/malzemeOnay/store';
import personelIzin from '../modules/personelIzin/store';
import personelTalepOnay from '../modules/personelTalepOnay/store';
import adayTespitOnay from '../modules/adayTespitOnay/store';
import personelSevkOnay from '../modules/personelSevkOnay/store';
import kullanicilar from '../modules/kullanicilar/store';
import kysFormu from '../modules/kysFormu/store';
import kycFormu from '../modules/kycFormu/store';
import kyeFormu from '../modules/kyeFormu/store';
import mrfOnay from '../modules/mrfOnay/store';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'my-app',
  storage: localStorage
});

export const storeOptions = {
  modules: {
    app,
    odemeTalep,
    satinAlmaOdemeTalep,
    malzemeOnay,
    personelIzin,
    personelTalepOnay,
    adayTespitOnay,
    personelSevkOnay,
    kullanicilar,
    kysFormu,
    kycFormu,
    kyeFormu,
    mrfOnay,
  },
  state: {
    canAddUser: false
  },
  state: {
    isKysUser: false
  },
  state: {
    isKysAdmin: false
  },
  state: {
    isHaveConfirmRight: false
  },
  state: {
    isHaveReportRight: false
  },
  state: {
    isHaveReportRightINS: false,
    userEmail: null
  },
  mutations: {
    setCanAddUser(state, canAddUser) {
      state.canAddUser = canAddUser;
    },
    setIsKysUser(state, isKysUser) {
      state.isKysUser = isKysUser;
    },
    setIsKysAdmin(state, isKysAdmin) {
      state.isKysAdmin = isKysAdmin;
    },
    setIsHaveConfirmRight(state, isHaveConfirmRight) {
      state.isHaveConfirmRight = isHaveConfirmRight;
    },
    setIsHaveReportRight(state, isHaveReportRight) {
      state.isHaveReportRight = isHaveReportRight;
    },
    setIsHaveReportRightINS(state, isHaveReportRightINS) {
      state.isHaveReportRightINS = isHaveReportRightINS;
    },
    setUserEmail(state, userEmail) {
      state.userEmail = userEmail;
    }
  },
  plugins: [vuexPersist.plugin]
};

export default new Vuex.Store(storeOptions);
